import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import constants from 'helpers/constants';
import utils from 'helpers/utils';

const StyledDrawer = styled(SwipeableDrawer)
  .attrs((props) => {
    let attr = props;

    const baseColorVars = props.theme.color2Css('Drawer', 'MuiPaper-root', props.$color, {
      varPrefix: 'drawer',
      variables: true,
      type: constants.colorTypes.paper,
      childPrefix: '>'
    });

    return utils.styleProps(attr, baseColorVars.vars, {baseColor: baseColorVars.css});
  })`
  ${props => props.$css.baseColor}
  
  ${ComponentStyles}
`;

StyledDrawer.propTypes = {
  theme: PropTypes.object
};

export default StyledDrawer;
